module.exports = __webpack_public_path__ + "static/media/ship-bg-mobile-serenade.15158001.jpg";